import React, { useState, useContext } from 'react';
import StudentLayout from './components/StudentLayout';
import { AuthContext } from '../auth/AuthContext';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';

const Educators = () => {
  const { user } = useContext(AuthContext) ?? {};
  const isMatric = user?.program === 'matric';

  const [myEducators] = useState([
    {
      name: 'Mr. Johnson',
      subject: 'Mathematics',
      email: 'johnson@example.com',
      image: 'https://via.placeholder.com/80',
    },
    {
      name: 'Ms. White',
      subject: 'English',
      email: 'white@example.com',
      image: 'https://via.placeholder.com/80',
    },
  ]);

  const [availableEducators] = useState([
    {
      name: 'Mr. Smith',
      subject: 'Physics',
      image: 'https://via.placeholder.com/80',
    },
    {
      name: 'Ms. Patel',
      subject: 'Biology',
      image: 'https://via.placeholder.com/80',
    },
    {
      name: 'Mr. Lee',
      subject: 'Chemistry',
      image: 'https://via.placeholder.com/80',
    },
  ]);

 const sectionTitle = isMatric ? 'Your Educator' : 'Your Current Educators';
 const availableTitle = isMatric ? 'Available Educators' : 'Find a New Educator';

  return (
    <StudentLayout>
      <Box>
        <Stack spacing={3}>
          <Box>
            <Typography variant="h4" fontWeight={800} color="primary.main">
 {isMatric ? 'My Educator' : 'My Educators'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
 View and contact your {isMatric ? 'educator' : 'educators'} to stay on track with your learning
              plan.
            </Typography>
          </Box>

          <Card variant="outlined">
            <CardHeader
              avatar={<SchoolRoundedIcon color="primary" />}
              title={<Typography variant="h6">{sectionTitle}</Typography>}
              subheader="Reach out to your assigned educator directly."
            />
            <CardContent>
              <Grid container spacing={2}>
                {myEducators.map((educator) => (
                  <Grid item xs={12} md={6} key={educator.email}>
                    <Card variant="outlined">
                      <CardContent>
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Avatar src={educator.image} alt={educator.name} sx={{ width: 64, height: 64 }} />
                          <Box>
                            <Typography variant="subtitle1" fontWeight={700}>
                              {educator.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Subject:&nbsp;<strong>{educator.subject}</strong>
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Email:&nbsp;<strong>{educator.email}</strong>
                            </Typography>
                          </Box>
                        </Stack>
                        <Button
                          href={`mailto:${educator.email}`}
                          variant="outlined"
                          sx={{ mt: 2 }}
                          fullWidth
                        >
                          Contact
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined">
            <CardHeader
              avatar={<PersonRoundedIcon color="primary" />}
              title={<Typography variant="h6">{availableTitle}</Typography>}
              subheader="Discover additional educators and request a session."
            />
            <CardContent>
              <Grid container spacing={2}>
                {availableEducators.map((educator) => (
                  <Grid item xs={12} md={4} key={educator.name}>
                    <Card variant="outlined" sx={{ height: '100%' }}>
                      <CardContent>
                        <Stack spacing={2} alignItems="center">
                          <Avatar src={educator.image} alt={educator.name} sx={{ width: 72, height: 72 }} />
                          <Box textAlign="center">
                            <Typography variant="subtitle1" fontWeight={700}>
                              {educator.name}
                            </Typography>
                            <Chip label={educator.subject} size="small" color="secondary" variant="outlined" />
                          </Box>
                          <Button variant="contained" fullWidth>
 {isMatric ? 'Request Educator' : 'Book Educator'}
                          </Button>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </StudentLayout>
  );
};

export default Educators;